import request from './utils/request'


// 查询平台功能指南列表
export function listFunctionGuide(query) {
    return request({
      url: '/web/portal/functionGuide/list',
      method: 'get',
      params: query
    })
  }
  
  // 查询平台功能指南详细
  export function getFunctionGuide(id) {
    return request({
      url: '/web/portal/functionGuide/getById',
      method: 'get',
      params: { id: id }
    })
  }